module.exports = __webpack_public_path__ + "assets/img/bg_top.0049b335.png";